import { actionize, apiFetch, apiAction } from 'utils';
import { normalize, Schema } from 'normalizr';
import DuckEntity from './DuckEntity';

import { entity as contacts } from './contacts';

const schema = new Schema('bulkFilePages');

schema.define({
  contact: contacts.schema
});

const baseEntity = new DuckEntity('bulkFilePages', {
  schema
});

let types = {
  ROTATE_BEGIN: null,
  ROTATE_SUCCESS: null,
  ROTATE_ERROR: null
};
types = actionize(types, (action) => `schooladmin/bulkFilePages/${action}`);

const rotate = (object, rotation) => (dispatch) => {
  // Clear the image url for this page until the new one is fetched

  dispatch({
    type: types.ROTATE_BEGIN,
    payload: {
      result: normalize({
        ...object,
        page_image_url: null
      }, schema)
    }
  });

  return dispatch(apiAction(
    types.ROTATE_BEGIN, types.ROTATE_SUCCESS, types.ROTATE_ERROR,
    (state) => apiFetch.post(state, `${baseEntity.config.apiPath}/${object.id}/rotate`, {rotation}, {}),
    {rotation, entity: object, entityName: baseEntity.name, create: false, update: true},
    {bulk_file_page: schema}
  ));
};

export default baseEntity.reducer;

export const entity = {
  ...baseEntity,
  actions: {
    ...baseEntity.actions,
    rotate
  }
};
